// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2ARKA","content":"Consent_content__3aTAT","footer":"Consent_footer__1CwSc"};